<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->

    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <!-- <app-page-banner class="small-banner" title="About Us" subtitle="About Us"></app-page-banner> -->
        <!-- INNER PAGE BANNER END -->

        <!-- Project START -->
        <div class="section-full p-t10 p-b90 projects-outer-full mt-3">
            <div class="container">
                <!-- Section Title -->
                <div class="section-head center wt-small-separator-outer text-center text-white mb-4">
                    <!-- <h4>Psychotherapy Services
                    </h4> -->
                </div>

        
               
                <!-- Second Row (Content Left, Image Right) -->
                <!-- <div class="small-banner1" title="Our Mission" subtitle="Our Mission"><span class="sub-small-banner">Our Mission</span></div> -->
                 <div class="Space-banner">&nbsp;</div>
                 <div>&nbsp;</div>

                <!-- <div class="banner-title-outer">
                    <div class="banner-title-name">
                        <h4 style="color: #333;">Our Mission</h4>
                    </div>
                </div> -->

                <div class="row  mb-5">
                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="Our Mission" subtitle="Our Mission"></app-page-banner>
                    </div>
                    <div class="col-md-6">
                        <div class="about-image">
                            

                            <img src="assets/images/mission.png" alt="About Soul Space" class="img-fluid" style="
                            height: 300px;
                            width: 94%;
                        ">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="about-content" >
                            <p>
                                Soul Space Wellness & Behavioural Health Clinic is dedicated to promoting holistic
                                well-being by offering compassionate care for mental, emotional, and physical
                                health. Our goal is to create a safe, healing environment for personal growth and
                                resilience.
                            </p>
                        </div>
                    </div>
                   
                </div>

                <!-- Third Row (Image Left, Content Right) -->
                <!-- <app-page-banner class="small-banner" title="Our Vision" subtitle="Our Vision"></app-page-banner> -->
                <!-- <div class="small-banner1" title="Our Vision" subtitle="Our Vision"><span class="sub-small-banner">Our Vision</span></div> -->



                <div class="row mb-5">
                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="Our Vision" subtitle="Our Vision"></app-page-banner>

                        </div>
                    <div class="col-lg-6 col-md-12">
                        <h6></h6>
                        <div class="about-image">
                            <img src="assets/images/thumbnail_beautiful-alstroemeria-flowers.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 300px;
                            width: 94%;
                        ">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="about-content mobcontent">
                            <p>
                                We envision a world where individuals have access to supportive and integrative
                                care that nurtures mind, body, and spirit, empowering them to lead fulfilling lives.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Fourth Row (Content Left, Image Right) -->
                <!-- <div class="small-banner1" ><span class="sub-small-banner">Who are we?</span></div> -->


                <div class="row mb-5">

                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="Who are we?" subtitle="Who are we?"></app-page-banner>

                        </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="about-image">
                            <img src="assets/images/flat-lay-of-autumnal-maple-leaves-in-circle-isolat-2024-11-19-12-51-53-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 300px;
                            width: 94%;
                        ">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="about-content mobcontent" >
                            <p >
                                Soul Space was founded with the belief that mental wellness is a journey, not a destination. Our founder, Dr Raman Sodhi, envisioned a place where individuals could find holistic support for their mental health and well-being with utmost confidentiality and dignity.
                            </p>
                        </div>
                    </div>
                </div>

               <!--OUR Journey-->
               <!-- <div class="small-banner1" ><span class="sub-small-banner">Our Journey</span></div> -->


               <div class="row  mb-5">


                <div class="col-lg-12 col-md-12">
                    <app-page-banner class="small-banner1" title="Our Journey" subtitle="Our Journey"></app-page-banner>

                  
                    <div class="timeline-cover">
                        <div class="timeline">
                            <div class="timeline-line"></div>
                        
                            <div *ngFor="let item of timelineData; let i = index" class="timeline-item">
                            
                            <!-- Year Circle (Click to Show Content) -->
                            <div class="timeline-year" 
                                [ngClass]="{ 'timeline-year-odd': i % 2 === 0, 'timeline-year-even': i % 2 !== 0, 'active': selectedIndex === i }"
                                (click)="toggleContent(i)">
                                {{ item.date }}
                            </div>
                        
                            <!-- Timeline Content -->
                            <div class="timeline-content"
                                [ngClass]="{ 'timeline-content-odd': i % 2 === 0, 'timeline-content-even': i % 2 !== 0, 'active': selectedIndex === i }">
                                <h6>{{ item.title }}</h6>
                                <p>{{ item.description }}</p>
                            </div>
                        
                            </div>
                        </div>
                   </div>
                </div>
           
            </div>

            <!--Why Choose Soul Space?-->
            <!-- <div class="small-banner1" ><span class="sub-small-banner">Why Choose Soul Space?</span></div> -->


               <div class="row  mb-5">
                <div class="col-lg-12 col-md-12">
                    <app-page-banner class="small-banner1" title="Why Choose Soul Space?" subtitle="Why Choose Soul Space?"></app-page-banner>

                    </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-image">
                        <img src="assets/images/thumbnail_silhouette-image-of-many-people-holding-and-puttin-2024-11-25-17-09-57-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                        height: 300px;
                        width: 94%;
                    ">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-content mobcontent">
                        <p >
                            <ul class="centered-list">
                                <li>Personalized Care from experienced professionals.</li>
                                <li>Age-specific treatment plan.</li>
                                <li>Perfect blend of modern scientific treatments that are <span style="margin-left: 27px;">clinically proven.</span></li>
                                <li>Holistic Wellbeing - Mind, Body & Soul.</li>
                            </ul>
                    </div>
                </div>
            </div>

            <!--Embracing Mental Wellbeing in a Changing World-->
     
            <!-- <div class="small-banner1" ><span class="sub-small-banner">Embracing Mental Wellbeing in a Changing World</span></div> -->


            <div class="row  mb-5">
                <div class="col-lg-12 col-md-12">
                    <app-page-banner class="small-banner1" title="Embracing Mental Wellbeing in a Changing World" subtitle="Embracing Mental Wellbeing in a Changing World"></app-page-banner>

                    </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-image">
                        <img src="assets/images/an-asian-woman-holds-a-globe-in-green-forest-symbo-2024-10-12-00-07-02-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                        height: 300px;
                        width: 94%;
                    ">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="about-content mobcontent">
                        <p >
                            The rapid technological advances of recent decades have profoundly impacted our individual and collective lifestyles. These changes necessitate a restructuring of our belief systems, urging us to place mental and emotional wellbeing on par with physical health, rather than viewing it as a distant corollary of “good physical health”.
                                <br><br>In recent years, there has been a global shift in how we perceive wellbeing. India took a pioneering step in 2011 by attempting to put mental health on the WHO agenda when only non-communicable diseases were given importance. This effort culminated on May 2,2016, when the then UN Secretary General António Guterres launched mental health as a flagship program.
                                <br><br>Soul Space was born from the global awakening, formed in December, 2023, we are a registered entity of dedicated mental health professionals united by a common cause: to bring the benefits of positive mental health and wellbeing to the general population.
                    </div>
                </div>
            </div>
              

                
               
               

            </div>

        </div>
    </div>

    <app-footer1></app-footer1>
</div>
<app-loader></app-loader>